import { useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Search from "@material-ui/icons/Search";
import { useSearchFieldStyles } from "./styles";
import { useSearchParams } from "../../../../hooks/useSearchParams";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { MdSearchOff } from "react-icons/md";

type SearchFieldProps = {
    placeholder?: string;
    style?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
};

export default function SearchField({ placeholder, style, inputStyle }: SearchFieldProps) {
    const history = useHistory();
    const searchParams = useSearchParams();
    const { pathname } = useLocation();
    const { classes } = useSearchFieldStyles();
    const searchRef = useRef<HTMLInputElement>(null);

    function handleSubmit(event: React.FormEvent) {
        event.preventDefault();

        const searchValue = searchRef.current?.value;

        if (searchValue) {
            searchParams.set("search", searchValue);
        } else {
            searchParams.delete("search");
        }

        ["page", "order", "order_by"].forEach((param) => {
            if (searchParams.has(param)) {
                searchParams.delete(param);
            }
        });

        return history.replace(`${pathname}?${searchParams}`);
    }

    function clearSearch() {
        if (searchRef?.current?.value) {
            searchRef.current.value = "";
            searchParams.delete("search");
            ["page", "order", "order_by"].forEach((param) => {
                if (searchParams.has(param)) {
                    searchParams.delete(param);
                }
            });

            return history.replace(`${pathname}?${searchParams}`);
        }
    }

    return (
        <form onSubmit={handleSubmit} className={classes.form} style={style}>
            <TextField
                inputRef={searchRef}
                size="small"
                label="Buscar"
                variant="outlined"
                defaultValue={searchParams.get("search") || ""}
                placeholder={placeholder || "Buscar..."}
                className={classes.root}
                style={inputStyle}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search htmlColor="#A2A2A2" />
                        </InputAdornment>
                    ),
                }}
            />
            <Box display="flex" alignItems="center">
                <Button
                    type="submit"
                    variant="contained"
                    startIcon={<Search />}
                    className={classes.searchButton}
                >
                    Buscar
                </Button>
                {searchParams.get("search") && (
                    <Button
                        variant="outlined"
                        className={classes.buttonCancelSearch}
                        startIcon={<MdSearchOff />}
                        onClick={clearSearch}
                    >
                        LIMPAR
                    </Button>
                )}
            </Box>
        </form>
    );
}
